<template>
  <div>
    <b-tabs justified active-nav-item-class="font-weight-bold text-uppercase text-dark" @activate-tab="refreshTab">
      <b-tab title="Resumen">
        <section class="metrics-dashboard"><header class="metrics-dashboard__header"><div><AppIcon name="insights" /><strong> Resumen operativo</strong><small>Vista consolidada para los filtros seleccionados.</small></div><b-button variant="link" class="list-view-icon-btn" v-b-tooltip.hover title="Actualizar resumen" @click="refreshSummary"><AppIcon name="refresh" /></b-button></header>
          <b-overlay :show="arrUnitMeasurement == 'S/D'" rounded="sm"><b-row class="metrics-dashboard__stats"><b-col md="6"><div class="metrics-stat"><small>Cantidad de ítems</small><strong v-for="(item,index) in arrUnitMeasurement" :key="'detail_unit_'+index">{{formatNumber(item.count)}} {{item.reference}}</strong></div></b-col><b-col md="6"><div class="metrics-stat"><small>Total facturado</small><strong>{{formatCurrency(total)}}</strong></div></b-col></b-row></b-overlay>
          <b-row><b-col md="6"><section class="metrics-panel"><header><div><AppIcon name="format_list_numbered" /><strong>Ítems más vendidos</strong></div><small>Por cantidad</small></header><b-overlay :show="arrItems == 'S/D'" rounded="sm"><div class="metrics-panel__rows"><div v-for="(item,index) in arrItems" :key="'detail_items_'+index" class="metrics-row"><span class="metrics-row__rank">{{index+1}}</span><div class="metrics-row__label"><strong><span v-if="item.code">{{item.code}} · </span>{{item.name}}</strong><span class="metrics-row__bar"><i :style="{width:percentage(item.count, arrItems)+'%'}"></i></span></div><strong>{{formatNumber(item.count)}} {{item.um_reference}}</strong></div><div v-if="arrItems !== 'S/D' && !arrItems.length" class="metrics-empty">No hay datos para mostrar.</div></div></b-overlay></section></b-col><b-col md="6"><section class="metrics-panel"><header><div><AppIcon name="store" /><strong>Totales por punto de venta</strong></div><small>Importe acumulado</small></header><b-overlay :show="arrPointSale == 'S/D'" rounded="sm"><div class="metrics-panel__rows"><div v-for="(item,index) in arrPointSale" :key="'detail_point_'+index" class="metrics-row"><span class="metrics-row__rank">{{index+1}}</span><div class="metrics-row__label"><strong>{{item.point_sale}} · {{item.reference}}</strong></div><strong>{{formatCurrency(item.count)}}</strong></div><div v-if="arrPointSale !== 'S/D' && !arrPointSale.length" class="metrics-empty">No hay datos para mostrar.</div></div></b-overlay></section></b-col></b-row>
        </section>
      </b-tab>
      <b-tab title="Datos">
        <DynamicSummary ref="dynamicSummary" storage-key="dynamic_summary_metrics_sales" export-filename="metricas-ventas" :dimensions="report.dimensions" :default-groups="report.defaultGroups" :load-report="loadReport" :export-options="[{key:'detail-items',label:'CSV detalle'},{key:'list-sales-no-pivot',label:'CSV base'}]" :exporting="exporting" quantity-label="Cantidad" @export="downloadSource" @error="showReportError" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
  import serviceAPI from './../services'
  import Funciones from '@/handler/funciones'
  import Helper from '@/handler/helper'     
  import DynamicSummary from '@/components/inc/reporting/DynamicSummary'

  export default {
    props:{
      filters: {
        type: Object,
        default: null,
      },
    },    
    components: {
      DynamicSummary,
    },    
    data() {
      return {                
        total: 0,
        arrItems: 'S/D',        
        arrUnitMeasurement: 'S/D',
        arrPointSale: 'S/D',
        currency: 'ARS',
        itemsForceUpdate: 0,   
        exporting: false,
        report: {
          defaultGroups: ['year', 'month'],
          dimensions: [
            { key: 'year', label: 'Año' }, { key: 'month', label: 'Mes' }, { key: 'point_sale', label: 'Punto de venta' },
            { key: 'seller', label: 'Vendedor' }, { key: 'customer', label: 'Cliente' }, { key: 'item', label: 'Ítem' }, { key: 'currency', label: 'Moneda' },
          ],
        },
      }
    },
    mounted() {      
      this.getResumen()   
    },    
    methods: {          
      // RESUMEN
      getResumen() {                      
        var seller = Helper.getSeller()
        if(seller) {
          this.filters.sellers = []
          this.filters.sellers.push({
            code: Helper.getSeller().id,
            label: Helper.getSeller().name,
          })   
        }
        
        var result = serviceAPI.getResumen('sales',this.filters)        
        result.then((response) => {                   
          var data = response.data

          //currency
          if(data.currency){
            this.currency = data.currency
          }

          //total
          this.total = parseFloat(data.total)   

          //unit          
          this.arrUnitMeasurement = []
          for(const prop in data.unit) {
            this.arrUnitMeasurement.push({
              reference: prop,
              count: parseFloat(data.unit[prop]),
            })
          }          

          //point sale          
          this.arrPointSale = []
          for(const prop in data.point_sale) {
            this.arrPointSale.push({
              point_sale: data.point_sale[prop].point_sale,
              reference: data.point_sale[prop].reference,
              count: parseFloat(data.point_sale[prop].amount_total),
            })
          }     

          //items          
          this.arrItems = []
          for(const prop in data.items) {
            this.arrItems.push({
              code: data.items[prop].code,
              name: data.items[prop].name,              
              count: parseFloat(data.items[prop].count),
              um_reference: data.items[prop].um_reference,
            })
          }
          Funciones.sortArrayInteger(this.arrItems, 'count', -1)                  

          this.setItemForceUpdate()          
        })                          
      },   
      refreshSummary() {
        this.getResumen()
      },
      refreshTab(index) {
        if(index === 0) this.refreshSummary()
        else this.$nextTick(() => { if(this.$refs.dynamicSummary) this.$refs.dynamicSummary.reload() })
      },
      setItemForceUpdate() {
        this.itemsForceUpdate = this.itemsForceUpdate + 1
      },
      formatNumber(value) {
        return Intl.NumberFormat('es-AR',{ maximumFractionDigits: 0 }).format(parseFloat(value) || 0)
      },
      formatCurrency(value) {
        try { return Intl.NumberFormat('es-AR',{style:'currency',currency:this.currency || 'ARS'}).format(parseFloat(value) || 0) } catch (e) { return Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(parseFloat(value) || 0) }
      },
      percentage(value, values) {
        var maximum = Math.max.apply(null, (values || []).map(item => parseFloat(item.count) || 0).concat([1]))
        return Math.round(((parseFloat(value) || 0) / maximum) * 100)
      },
     
      // DOWNLOAD: se consulta el origen sólo al exportar.
      downloadSource(type) {
        this.exporting = true
        serviceAPI.getReportExport('sales', this.filters)
          .then(response => {
            var data = (response.data && response.data.detailItem) || []
            if(type == 'list-sales-no-pivot') Funciones.exportToCSV(this.prepareExportListSaleNoPivot(data), 'list-sales-no-pivot')
            else Funciones.exportToCSV(data, 'source-sales-detail-items')
          })
          .catch(error => this.showReportError(error))
          .finally(() => { this.exporting = false })
      },
      loadReport(params) {
        return serviceAPI.getDynamicReport('sales', Object.assign({}, this.filters || {}, params))
      },
      showReportError(error) {
        this.$awn.alert(error && error.message ? error.message : 'No se pudo cargar el reporte.')
      },

      // DOWNLOAD CONFIG
      downloadConfigPivot(jsonData) {
        var encodedUri = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(jsonData));

        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "pivot.json");
        document.body.appendChild(link); 
        link.click();
        document.body.removeChild(link);                 
      },      

      // PIVOT
      openPivot(type) {
        this.pivot.data = this.processPivot(type)
        
        this.modal.pivot.title = 'Pivot'        
        this.modal.pivot.active = true
      },      
      processPivot(type, download=false) {
        var jsonData = null

        switch(type) {
          case 'list-sales':
            jsonData = {
              dataSource: {                  
                data: this.arrSource.listSales,
              },
              slice: {
                rows: [
                  {
                    uniqueName: "date.Year",
                    sort: "asc",
                  },                  
                  {
                    uniqueName: "pointSaleName",
                    sort: "asc",
                  },                  
                  {
                    uniqueName: "customerName",
                    sort: "asc",
                  },           
                  {
                    uniqueName: "referenceSale",
                    sort: "asc",
                  },                                                      
                  {
                    uniqueName: "itemName",
                    sort: "asc",
                  }                                    
                ],
                columns: [
                  {
                    uniqueName: "currency",
                    sort: "asc",
                  },                  
                  {
                    uniqueName: "date.Month",
                    sort: "asc",
                  }
                ],
                measures: [
                  {
                    uniqueName: "count",
                    aggregation: "sum"
                  },   
                  {
                    uniqueName: "total",
                    aggregation: "sum"
                  },                                  
                ],
                expands: {
                  expandAll: false,
                  rows: [],
                  columns: []
                },
                drills: {
                  drillAll: false
                }
              },
              options: {
                grid: {
                  type: "compact",
                  title: "",
                  showFilter: true,
                  showHeaders: true,
                  showTotals: false,
                  showGrandTotals: "off",
                  showHierarchies: true,
                  showHierarchyCaptions: true,
                  showReportFiltersArea: true
                },
                configuratorActive: false,
                configuratorButton: true,
                showAggregations: true,
                showCalculatedValuesButton: true,
                drillThrough: true,
                showDrillThroughConfigurator: true,
                sorting: "on",
                datePattern: "dd/MM/yyyy",
                dateTimePattern: "dd/MM/yyyy HH:mm:ss",
                saveAllFormats: false,
                showDefaultSlice: true,
                defaultHierarchySortName: "asc"
              },
              formats: [
                {
                  name: "",
                  thousandsSeparator: " ",
                  decimalSeparator: ".",
                  decimalPlaces: 2,
                  maxSymbols: 20,
                  currencySymbol: "",
                  currencySymbolAlign: "left",
                  nullValue: " ",
                  infinityValue: "Infinity",
                  divideByZeroValue: "Infinity"
                }
              ],
              localization: "/static/webdatarocks/es.json"                     
            }             
            break

          case 'detail-items':        
            jsonData = {
              dataSource: {                  
                data: this.arrSource.detailItem,
              },
              slice: {
                rows: [
                  {
                    uniqueName: "date.Year",
                    sort: "asc",
                  },
                  {
                    uniqueName: "sellerName",
                    sort: "asc",
                  },                  
                  {
                    uniqueName: "customerName",
                    sort: "asc",
                  },                  
                  {
                    uniqueName: "itemName",
                    sort: "asc",
                  }                                    
                ],
                columns: [
                  {
                    uniqueName: "currency",
                    sort: "asc",
                  },                  
                  {
                    uniqueName: "date.Month",
                    sort: "asc",
                  }
                ],
                measures: [
                  {
                    uniqueName: "count",
                    aggregation: "sum"
                  },   
                  {
                    uniqueName: "total",
                    aggregation: "sum"
                  },                                  
                ],
                expands: {
                  expandAll: false,
                  rows: [],
                  columns: []
                },
                drills: {
                  drillAll: false
                }
              },
              options: {
                grid: {
                  type: "compact",
                  title: "",
                  showFilter: true,
                  showHeaders: true,
                  showTotals: false,
                  showGrandTotals: "off",
                  showHierarchies: true,
                  showHierarchyCaptions: true,
                  showReportFiltersArea: true
                },
                configuratorActive: false,
                configuratorButton: true,
                showAggregations: true,
                showCalculatedValuesButton: true,
                drillThrough: true,
                showDrillThroughConfigurator: true,
                sorting: "on",
                datePattern: "dd/MM/yyyy",
                dateTimePattern: "dd/MM/yyyy HH:mm:ss",
                saveAllFormats: false,
                showDefaultSlice: true,
                defaultHierarchySortName: "asc"
              },
              formats: [
                {
                  name: "",
                  thousandsSeparator: " ",
                  decimalSeparator: ".",
                  decimalPlaces: 2,
                  maxSymbols: 20,
                  currencySymbol: "",
                  currencySymbolAlign: "left",
                  nullValue: " ",
                  infinityValue: "Infinity",
                  divideByZeroValue: "Infinity"
                }
              ],
              localization: "/static/webdatarocks/es.json"                     
            }             
            break
        }

        if(!download) {
          return jsonData
        } else {
          this.downloadConfigPivot(jsonData)
        }        
      },   

      // PREPARE EXPORT
      prepareExportListSaleNoPivot(data) {        
        var arrExport = []
        // El endpoint puede serializar los importes como número o como texto
        // según el driver/configuración de la base. CSV siempre usa coma.
        var decimal = (value) => value === undefined || value === null || value === '' ? '' : String(value).replace('.', ',')
        
        var id = 0
        data.forEach(element => {
          
          if(id != element.id) {
            if(id>0) {
              arrExport.push([])
            }

            id = element.id
          
            var customersID = element.customerId
            var customersCode = element.customerCode
            var customersName = element.customerName
            var methodsPaymentID = element.methodsPaymentId
            var methodsPaymentName = element.methodsPaymentName
            var voucherReference = element.typeVoucherName + ' ' + element.pointSaleId.toString().padStart(4,'0') + '-' + element.numero.toString().padStart(8,'0')
            var currencyID = element.currencyId
            var currencyName = element.currencyName
            var methodsAcopioID = element.methodsAcopioId
            var methodsAcopioName = element.methodsAcopioName        

            arrExport.push({
              id: element.id, 
              date: element.date,                      
              date_expiration: element.dateExpiration,                      
              voucherReference: voucherReference,              
              customersID: customersID,
              customersCode: customersCode,
              customersName: customersName,
              methodsPaymentID: methodsPaymentID,
              methodsPaymentName: methodsPaymentName,
              methodsAcopioID: methodsAcopioID,
              methodsAcopioName: methodsAcopioName,            
              currencyID: currencyID,
              currencyName: currencyName,
              percentage: decimal(element.percentageDiscount),
              discount: decimal(element.amountDiscount),
              iva: decimal(element.amountIva),
              total: decimal(element.total),
              observations: element.observations,
              observations_internal: element.observationsInternal,              
              itemCode: "",
              itemName: "",              
              priceListID: "",
              priceListName: "",            
              quantity: "",
              unitMeasurementID: "",
              unitMeasurementName: "",            
              unit_price: "",
              amount_net: "",
              amount_discount: "",
              amount_iva: "",                          
              amount_total: "",
            })
          } 
            
          var itemCode = element.itemCode
          var itemName = element.itemName          
          var unitMeasurementID = element.unitMeasurementId
          var unitMeasurementName = element.unitMeasurementReference
          var priceListID = element.priceListId
          var priceListName = element.priceListName
                   
          arrExport.push({        
            id: "", 
            date: "",                      
            date_expiration: "",
            voucherReference: "",              
            customersID: "",
            customersCode: "",
            customersName: "",
            methodsPaymentID: "",
            methodsPaymentName: "",
            methodsAcopioID: "",
            methodsAcopioName: "",            
            currencyID: "",
            currencyName: "",
            percentage: "",
            discount: "",
            iva: "",            
            total: "",            
            observations: "",
            observations_internal: "",
            itemCode: itemCode,
            itemName: itemName,            
            priceListID: priceListID,
            priceListName: priceListName,
            quantity: decimal(element.detail_quantity),
            unitMeasurementID: unitMeasurementID,
            unitMeasurementName: unitMeasurementName,
            unit_price: decimal(parseFloat(element.detail_price_unit || 0).toFixed(2)),
            amount_net: decimal(element.detail_amount_net),
            amount_discount: decimal(element.detail_discount),
            amount_iva: decimal(element.detail_iva),
            amount_total: decimal(element.detail_amount),
          })
              
        });
        
        return arrExport
      },      
    },
  }
</script>
<style scoped>
  .metrics-dashboard{padding:.75rem}.metrics-dashboard__header,.metrics-panel>header,.metrics-row{display:flex;align-items:center;justify-content:space-between;gap:.75rem}.metrics-dashboard__header{margin-bottom:.75rem}.metrics-dashboard__header small,.metrics-panel header small{display:block;color:var(--app-color-text-muted);font-size:.75rem}.metrics-dashboard__stats{margin-bottom:.75rem}.metrics-stat,.metrics-panel{border:1px solid var(--app-color-border);border-radius:.35rem;background:var(--app-color-surface)}.metrics-stat{padding:1rem;min-height:86px}.metrics-stat small{display:block;color:var(--app-color-text-muted);font-size:.75rem}.metrics-stat strong{display:block;font-size:1.05rem;color:var(--app-color-text-primary)}.metrics-panel{overflow:hidden}.metrics-panel>header{padding:.65rem .75rem;background:var(--app-color-surface-subtle);border-bottom:1px solid var(--app-color-border)}.metrics-panel__rows{max-height:420px;overflow:auto}.metrics-row{padding:.55rem .75rem;border-bottom:1px solid var(--app-color-border);font-size:.82rem}.metrics-row:last-child{border-bottom:0}.metrics-row__rank{width:22px;height:22px;border-radius:50%;background:var(--app-color-primary-soft);color:var(--app-color-primary);text-align:center;line-height:22px;font-weight:700}.metrics-row__label{flex:1;min-width:0}.metrics-row__label strong{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.metrics-row__bar{display:block;height:3px;margin-top:.35rem;background:var(--app-color-border)}.metrics-row__bar i{display:block;height:100%;background:var(--app-color-primary)}.metrics-empty{padding:1rem;text-align:center;color:var(--app-color-text-muted)}
</style>
